import type { CommunicationDto, CreateUpdateCommunicationDto, GetCommunicationsInput } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  apiName = 'Default';
  

  create = (input: CreateUpdateCommunicationDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CommunicationDto>({
      method: 'POST',
      url: '/api/app/communication',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/communication/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CommunicationDto>({
      method: 'GET',
      url: `/api/app/communication/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getActiveList = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, CommunicationDto[]>({
      method: 'GET',
      url: '/api/app/communication/active-list',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCommunicationsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CommunicationDto>>({
      method: 'GET',
      url: '/api/app/communication',
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: CreateUpdateCommunicationDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CommunicationDto>({
      method: 'PUT',
      url: `/api/app/communication/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
